import React from "react";

function Welcome4Icon({width}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width||"505"}
      height={width||"379"}
      fill="none"
      viewBox="0 0 505 379"
    >
      <g fill="#432C5B" stroke="#432C5B" strokeWidth="6.415" opacity="0.05">
        <path d="M203.887 182.28c-2.564 11.728-13.026 20.537-25.512 20.537a6.027 6.027 0 00-6.027 6.028 6.027 6.027 0 006.027 6.027c19.106 0 34.977-14.11 37.745-32.457 11.698-1.264 22.497-6.477 30.856-15.009a6.027 6.027 0 10-8.611-8.437c-7.393 7.546-17.281 11.702-27.843 11.702-21.493 0-38.978-17.485-38.978-38.978a6.027 6.027 0 00-12.055 0c0 25.89 19.384 47.323 44.398 50.587zM229.407 234.553a6.027 6.027 0 00-6.027-6.028c-28.139 0-51.032 22.893-51.032 51.033 0 .291.01.582.015.874a51.209 51.209 0 00-6.846-.473 6.028 6.028 0 100 12.055c21.492 0 38.977 17.485 38.977 38.978a6.027 6.027 0 0012.055 0c0-21.386-13.23-39.731-31.93-47.309a39.68 39.68 0 01-.216-4.125c0-21.493 17.485-38.978 38.977-38.978a6.027 6.027 0 006.027-6.027z"></path>
        <path d="M435.146 183.117a50.893 50.893 0 00-15.169-36.29 50.625 50.625 0 002.311-15.144c0-24.812-17.803-45.534-41.303-50.09a38.061 38.061 0 002.727-14.202c0-15.717-9.55-29.243-23.15-35.089C337.903 14.255 313.12 3.5 294.104 3.5c-10.57 0-19.944 5.198-25.717 13.167C262.615 8.698 253.241 3.5 242.67 3.5c-19.016 0-43.798 10.755-66.457 28.802-13.601 5.846-23.151 19.372-23.151 35.089 0 4.925.932 9.724 2.728 14.201-23.5 4.557-41.303 25.279-41.303 50.091 0 5.158.775 10.235 2.31 15.144a50.893 50.893 0 00-15.169 36.29 50.732 50.732 0 009.012 28.912c-5.9 8.528-9.012 18.477-9.012 28.952 0 18.555 10.116 35.555 26.132 44.519a57.888 57.888 0 00-.415 6.915c0 25.029 16.327 47.158 40.015 54.699 10.303 17.634 29.072 28.479 49.593 28.479 22.499 0 42.007-13.004 51.434-31.884 9.428 18.88 28.936 31.884 51.434 31.884 20.522 0 39.29-10.845 49.594-28.479 23.688-7.542 40.014-29.671 40.014-54.699 0-2.31-.139-4.623-.415-6.915 16.017-8.964 26.132-25.964 26.132-44.519 0-10.475-3.112-20.424-9.011-28.952a50.731 50.731 0 009.011-28.912zM216.953 363.539c-16.9 0-32.3-9.318-40.19-24.316a6.024 6.024 0 00-3.767-3.014c-19.781-5.324-33.596-23.332-33.596-43.794 0-3.062.309-6.129.917-9.117a6.028 6.028 0 00-3.457-6.71c-14.079-6.259-23.177-20.236-23.177-35.607 0-6.991 1.813-13.674 5.273-19.593 8.998 7.933 20.795 12.762 33.705 12.762a6.027 6.027 0 000-12.055c-21.493 0-38.978-17.485-38.978-38.978 0-11.569 5.105-22.473 14.006-29.913a6.025 6.025 0 001.72-6.89 38.742 38.742 0 01-2.867-14.631c0-21.492 17.485-38.977 38.977-38.977 21.492 0 38.978 17.485 38.978 38.977a6.027 6.027 0 1012.054 0c0-27.036-21.137-49.218-47.754-50.915a25.952 25.952 0 01-3.68-13.377c0-10.744 6.523-19.991 15.815-23.997a5.963 5.963 0 001.051-.423 25.978 25.978 0 019.253-1.7c10.092 0 19.101 5.643 23.512 14.728a6.026 6.026 0 008.055 2.789 6.026 6.026 0 002.789-8.055c-5.036-10.37-14.567-17.822-25.542-20.462 15.384-9.387 30.528-14.716 42.62-14.716 10.857 0 19.69 8.832 19.69 19.69v77.995c-5.416-4.296-12.256-6.872-19.69-6.872a6.027 6.027 0 000 12.055c10.857 0 19.69 8.832 19.69 19.69v144.882c-7.494-9.669-18.059-16.966-30.487-20.305a6.028 6.028 0 00-3.128 11.642c19.792 5.318 33.615 23.328 33.615 43.8 0 25.037-20.37 45.407-45.407 45.407zm182.962-86.951a6.03 6.03 0 00-3.458 6.711c.609 2.988.917 6.055.917 9.117 0 20.462-13.815 38.47-33.595 43.793a6.026 6.026 0 00-3.767 3.015c-7.891 14.997-23.291 24.315-40.191 24.315-25.037 0-45.406-20.37-45.406-45.407 0-1.695-.079-3.375-.226-5.04a6.031 6.031 0 00.226-1.617V112.396c0-10.858 8.833-19.69 19.689-19.69a6.027 6.027 0 100-12.055c-7.433 0-14.273 2.576-19.689 6.872V35.245c0-10.858 8.833-19.69 19.689-19.69 12.092 0 27.237 5.329 42.621 14.716-10.976 2.639-20.506 10.093-25.542 20.462a6.025 6.025 0 002.789 8.055 6.027 6.027 0 008.055-2.79c4.411-9.084 13.42-14.726 23.511-14.726 3.258 0 6.376.604 9.254 1.699a5.94 5.94 0 001.049.423c9.293 4.005 15.816 13.252 15.816 23.997 0 4.758-1.267 9.344-3.68 13.377-26.616 1.697-47.754 23.879-47.754 50.915a6.028 6.028 0 1012.055 0c0-21.492 17.485-38.977 38.977-38.977 21.493 0 38.978 17.485 38.978 38.977 0 5.018-.965 9.941-2.867 14.631a6.027 6.027 0 001.72 6.89c8.901 7.44 14.005 18.344 14.005 29.913 0 21.493-17.485 38.978-38.977 38.978a6.027 6.027 0 00-6.027 6.027 6.027 6.027 0 006.027 6.028c12.91 0 24.707-4.829 33.705-12.762 3.46 5.919 5.272 12.602 5.272 19.593 0 15.371-9.097 29.348-23.176 35.607z"></path>
        <path d="M371.255 196.374c-12.486 0-22.948-8.809-25.512-20.537 25.015-3.264 44.398-24.697 44.398-50.587a6.027 6.027 0 00-12.055 0c0 21.492-17.485 38.977-38.977 38.977-10.563 0-20.451-4.155-27.844-11.702a6.027 6.027 0 00-8.523-.086 6.026 6.026 0 00-.088 8.523c8.36 8.533 19.158 13.745 30.857 15.01 2.767 18.347 18.638 32.457 37.744 32.457a6.028 6.028 0 100-12.055zM351.965 267.094a51.22 51.22 0 00-6.846.473c.005-.292.015-.584.015-.875 0-28.139-22.893-51.032-51.032-51.032a6.027 6.027 0 00-6.027 6.028 6.027 6.027 0 006.027 6.027c21.492 0 38.978 17.485 38.978 38.977a39.7 39.7 0 01-.217 4.126c-18.7 7.578-31.93 25.922-31.93 47.308a6.028 6.028 0 1012.055 0c0-21.492 17.485-38.977 38.977-38.977a6.027 6.027 0 100-12.055z"></path>
      </g>
      <circle
        cx="49.452"
        cy="254.363"
        r="23.18"
        fill="#432C5B"
        stroke="#432C5B"
        strokeLinecap="round"
        strokeWidth="5.877"
      ></circle>
      <path
        fill="#432C5B"
        stroke="#432C5B"
        strokeLinecap="round"
        strokeWidth="5.877"
        d="M5.594 313.563c3.674-13.464 17.81-20.349 33.052-20.349h21.613c15.241 0 29.377 6.885 33.051 20.349a61.938 61.938 0 011.842 9.685c.176 1.639-1.181 3.267-3.257 3.267H7.01c-2.076 0-3.433-1.628-3.257-3.267a61.933 61.933 0 011.841-9.685z"
      ></path>
      <path
        stroke="#432C5B"
        strokeWidth="5.953"
        d="M105.495 266.368L176.937 191.95"
      ></path>
      <path
        stroke="#432C5B"
        strokeWidth="5.953"
        d="M179.085 192.521L268.387 192.521"
      ></path>
      <path
        stroke="#432C5B"
        strokeWidth="5.953"
        d="M348.759 135.965L478.248 135.965"
      ></path>
      <path
        stroke="#432C5B"
        strokeWidth="5.953"
        d="M266.587 194.617L346.959 133.594"
      ></path>
      <rect
        width="52.242"
        height="52.242"
        x="452.127"
        y="109.844"
        fill="#432C5B"
        rx="26.121"
      ></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="5.597"
        d="M468.453 138.763l5.597 4.198 12.594-15.393"
      ></path>
      <rect
        width="29.767"
        height="29.767"
        x="333.229"
        y="120.436"
        fill="#432C5B"
        rx="14.884"
      ></rect>
      <rect
        width="29.767"
        height="29.767"
        x="252.858"
        y="176.994"
        fill="#432C5B"
        rx="14.884"
      ></rect>
      <rect
        width="29.767"
        height="29.767"
        x="163.555"
        y="176.992"
        fill="#432C5B"
        rx="14.884"
      ></rect>
      <rect
        width="29.767"
        height="29.767"
        x="91.27"
        y="252.057"
        fill="#432C5B"
        rx="14.884"
      ></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="3.189"
        d="M100.573 268.535l3.189 2.392 7.176-8.771"
      ></path>
    </svg>
  );
}

export default Welcome4Icon;
